import { Action } from 'helpers/action-helpers';
import { AppState } from '../../pages/app/state';
import {
  SaveUserAction,
  GetUserAction,
  ActivateUserAction,
  DeactivateUserAction,
  SetUserAction
} from './actions';
import { connect, Dispatch } from 'react-redux';
import { Guid } from 'types/guid';
import { tenantSelector } from 'pages/settings/selectors';
import { User, GetBlankUser } from 'types/user';
import { UserManagement, UserManagementComponentProps, UserManagementActionProps } from './component';
import { connectionSelector } from 'components/connection-status/selectors';
import { permissionsSelector } from 'pages/login/selectors';

function mapStateToProps(state: AppState): UserManagementComponentProps {
  return {
    errorMessage: state.userManagement.errorMessage,
    isOnline: connectionSelector(state),
    isProcessing: state.userManagement.isProcessing,
    isLoadingUser: state.userManagement.isLoadingUser,
    language: tenantSelector(state).language,
    permissions: permissionsSelector(state),
    user: state.userManagement.user as User,
    requestSuccess: state.userManagement.requestSuccess
  };
}

function mapDispatchToProps(dispatch: Dispatch<Action>): UserManagementActionProps {
  return {
    loadUser: (userId: Guid) => dispatch(new GetUserAction(userId)),
    saveUser: (userId: Guid, user: User) => dispatch(new SaveUserAction(userId, user)),
    activateUser: (userId: Guid) => dispatch(new ActivateUserAction(userId)),
    deactivateUser: (userId: Guid) => dispatch(new DeactivateUserAction(userId)),
    setBlankUser: () => dispatch(new SetUserAction(GetBlankUser()))
  };
}

export const UserManagementPage = connect(mapStateToProps, mapDispatchToProps)(UserManagement);


// WEBPACK FOOTER //
// ./src/pages/user-management/index.ts